import { CYCLE_EVENTS_CRUD_ACTION_CONSTANTS } from '../actions/cycle_events_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['AssetCycleRunsIndex']);
export default standardReducerGenerator(CYCLE_EVENTS_CRUD_ACTION_CONSTANTS, initialState);
